const mockCreations = [
  {
    id: 1,
    image_url:
      "https://i.pinimg.com/736x/74/bd/fc/74bdfc98e50f96f9af8ea9406fe20b54.jpg",
    user_name: "Ana Uñas",
    products: [
      {
        id: 101,
        name: "Acrílico Rosa Pastel",
        price: 89.99,
        stock: 20,
      },
      {
        id: 102,
        name: "Monómero Profesional 250ml",
        price: 150.0,
        stock: 15,
      },
    ],
  },
  {
    id: 2,
    image_url:
      "https://i.pinimg.com/736x/5c/4d/f3/5c4df3e7e5a78f7a0d5ad6b48fcfdae2.jpg",
    user_name: "Estudio Glam",
    products: [
      {
        id: 103,
        name: "Pincel Kolinsky #8",
        price: 320.0,
        stock: 5,
      },
      {
        id: 101,
        name: "Acrílico Rosa Pastel",
        price: 89.99,
        stock: 20,
      },
    ],
  },
  {
    id: 3,
    image_url:
      "https://i.pinimg.com/736x/f7/ad/e0/f7ade0f511c7d9a63a517f7186239e50.jpg",
    user_name: "Uñas by Sofi",
    products: [
      {
        id: 104,
        name: "Acrílico Blanco Perlado",
        price: 95.5,
        stock: 12,
      },
      {
        id: 105,
        name: "Top Coat UV",
        price: 110.0,
        stock: 25,
      },
    ],
  },
];

export default mockCreations;
